import { useSelector } from 'react-redux';

import { selectSelectedInstrumentPrice, selectSelectedInstrumentPriceLoading } from 'store/entities/market/selectors';

import { setCountDecimals } from 'utils';

import { InlineLoader } from 'elements/loader';

import '../MainMarketInfo.scss';

type Props = {
  decimals: number | undefined;
};

const InstrumentPrice = ({ decimals }: Props) => {
  const selectedInstrumentPrice = useSelector(selectSelectedInstrumentPrice);
  const isInstrumentPriceLoading = useSelector(selectSelectedInstrumentPriceLoading);

  const isPriceChangeNegative = Number(selectedInstrumentPrice?.price_24h_change) < 0;

  return (
    <>
      {isInstrumentPriceLoading ? (
        <InlineLoader />
      ) : (
        <>
          <div className="price">{setCountDecimals(selectedInstrumentPrice?.close || 0, decimals || 2)}</div>
          <div className="price-change">
            <span>{_t('24h Change', 'MARKET_INFO.24_H')}</span>
            <span className={` ${isPriceChangeNegative ? 'red' : ''}`}>
              {`${isPriceChangeNegative ? '' : '+'}${selectedInstrumentPrice?.price_24h_change || 0}%`}
            </span>
          </div>
        </>
      )}
    </>
  );
};

export default InstrumentPrice;
